import Image from 'next/image'
import { withErrorBoundary } from '@/components/ErrorBounddary'

const Adv = () => {
  const features = [
    ['免费基础使用', '提供基础的免费自助赛事平台服务，并附带教学视频，需要更多教程可随时联系我们。'],
    ['实时更新·无纸记分', '比分、桌次、成绩排名、签到情况等实时展示，支持万人级赛事与无纸化记分。'],
    ['现代美学·多种赛制', '独立投屏控制中心，现代化界面与多赛制预设，让舞台效果即时升温。'],
    ['安全备份', '多重备份策略通过安全认证，面对突发网络攻击依然稳定可靠。'],
    ['全国一站式办赛', '全国合伙人体系覆盖从场地协调到现场执行的一站式服务。'],
    ['严选周边', '专用扑克、桌垫、报牌卡、赛事饮用水等专业物料全系覆盖。'],
  ]

  return (
    <div className="space-y-12">
      <div className="text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.4em] text-white/70">Capability Matrix</p>
        <h2 className="mt-3 text-3xl font-bold text-white sm:text-4xl">实时 · 安全 · 稳定 · 智能</h2>
        <p className="mt-3 text-base text-white/70">覆盖赛事创建、执行、复盘的完整数字化引擎</p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {features.map(([title, desc], index) => (
          <div
            key={title}
            className="group relative flex h-full flex-col rounded-3xl border border-white/10 bg-white/5 p-6 text-center text-white shadow-[0_15px_40px_rgba(4,7,16,0.35)] backdrop-blur transition-all duration-300 hover:-translate-y-2 hover:border-white/40"
          >
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-white/5 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10">
              <Image src={`/adv/${index + 1}.png`} width={48} height={48} alt="" className="opacity-80 brightness-0 invert" />
            </div>
            <h3 className="relative mt-6 text-xl font-semibold">{title}</h3>
            <p className="relative mt-3 text-sm text-white/70">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
export default withErrorBoundary(Adv)
